import axios from 'axios'
import { createBrowserHistory } from 'history'
import Configuration from '../api/Configuration'
import CookiesStorageService from '../CookiesStorageService'

const StorageService = CookiesStorageService.getService()
const { BASE_URL } = Configuration

axios.defaults.baseURL = BASE_URL
axios.defaults.headers.common['Content-Type'] = 'application/json'

/**
 *  Add a request interceptor
 */
axios.interceptors.request.use(
  (config) => {
    const thisConfig = config
    thisConfig.headers.Authorization = `Bearer ${StorageService.getAccessToken()}`
    thisConfig.headers['Cache-Control'] = 'no-cache'
    thisConfig.headers.language = (thisConfig.headers.language || CookiesStorageService?.getUserLanguage()?.toUpperCase() || 'EN')
    thisConfig.headers.Pragma = 'no-cache'
    thisConfig.headers.Expires = '0'
    thisConfig.headers.TZ = Intl.DateTimeFormat().resolvedOptions()?.timeZone
    return thisConfig
  },
  (error) => Promise.reject(error),
)

/**
 * Add a response interceptor
 */
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (window.location.pathname !== '/' &&
      error.response.status === 401 &&
      !error.response.config.url.includes('reset-password')) {
      CookiesStorageService.clearCookies()
      createBrowserHistory().push('/autherror')
      return window.location.reload()
    }

    return {
      status: error.response?.status || 500,
      message: error.response.data?.message ||
        error.response.data?.displayMessage ||
        error.response.data?.code,
      severity: 'error',
    }
  },
)
